import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

// action types
export const GET_TIPOS_MULTA_BOX = "getTiposMultaBox";

const state = {};

const getters = {};

const actions = {
  [GET_TIPOS_MULTA_BOX](context, filtros) {
    return new Promise(resolve => {
      if (JwtService.getToken()) {
        ApiService.setHeader();
        ApiService.post("tiposDeMultaBox", filtros).then(({ data }) => {
          resolve(data);
        });
      }
    });
  }
};

const mutations = {};

export default {
  state,
  actions,
  mutations,
  getters
};
